import { useContext } from "react";
import sortBy from "lodash/sortBy";
import { useQuery } from "react-query";

import { PermissionsContext } from "@providers";

import { fetchIntegrationsIfPermitted } from "@pages/settings/api";

import { useOrg } from "./useOrg";

/*
 * Returns query result with integrations sorted by id
 */
export const useIntegrations = () => {
  const org = useOrg();
  const { permissions } = useContext(PermissionsContext);

  return useQuery(
    ["integrations", { org, permissions }],
    () =>
      fetchIntegrationsIfPermitted(org?.id!, permissions).then((response) =>
        sortBy(response.integrations, (integration) => integration.id)
      ),
    {
      enabled: !!org,
    }
  );
};
